import { ApiPayload } from './api-payload.model';
import { InsuredPayload } from './insured.model';
import { AgentSection, CalculationAddOns, DiscountCode } from './offer';
import { PathPayload } from './path.model';
import { PolicyholderPayload } from './policyholder.model';
import { Backoffice } from './backoffice.model';
import { AgentCommision } from './allianz-agents.model';

export enum FormOfPayment {
  'Cash' = 'Cash',
  'CreditCard' = 'CreditCard',
  'BankTransfer' = 'FundsTransfer',
}
export interface AgentCommissionSplits {
  agentNumber: string;
  commissionPercent: number;
}

export interface PurchaseAgentPayload extends ApiPayload {
  path: PathPayload;
  policyholder: PolicyholderPayload;
  insureds: InsuredPayload[];
  backofficeSection?: Partial<Backoffice> | null;
  agentCommissionSplits?: AgentCommision[] | null;
  selectedOffert: {
    packageCodeName: string;
    addOns: CalculationAddOns;
  };
  discountCode: DiscountCode;
  agentSection?: AgentSection;
  formOfPayment?: FormOfPayment;
  agreements?: number[];
  emailWithDocumentsWasSent: boolean;
  calculationHashCode?: string;
}

export interface PurchaseAgentResponseResult {
  hashCode: string;
  policyStatus: 'P';
  calculatedPremium: number;
  recipientEmail: string;
  policyNumber: string;
}

export interface PurchaseAgentResponse {
  statusCode: number;
  message: 'Success';
  result: PurchaseAgentResponseResult;
  errors: null;
  timeGenerated: Date;
}
